<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.name }}</template>
        <template #description>{{ baseFeature.description }}</template>
        <template #content>
            <CmsAndApp :webImage="webImage" :appImage="appImage" />
        </template>
    </HeroSection>

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';
import WorksWith from '../../components/Blocks/WorksWith.vue';
import { getFeaturesByIds } from '../../router/features';

import webImage from '@/images/cms-1.png';
import appImage from '@/images/app-1.jpg';

const tips = [
    'Dedicated speaker management with bios, sessions, and materials.',
];

const baseFeature = getFeaturesByIds(['speakerportals'])[0];
const integrations = getFeaturesByIds(['eventapp', 'companyportals']);
</script>
